import {
  AppliedFilter,
  FilterArrayItem,
} from '@/pages/Shipments/ControlTower/types';
import { Flex } from 'antd';
import { Fragment, type FC } from 'react';
import { createPortal } from 'react-dom';
import { HeaderItem, PermissionsObject, TabItem } from '../types';
import PresetsDropdown, { PresetInterface } from './PresetsDropdown';
import ReportPanelContent from './ReportPanelContent';

//

interface DownloadReportPannelSectionProps {
  appliedHeaderList: HeaderItem[];
  setAppliedHeaderList?: React.Dispatch<React.SetStateAction<HeaderItem[]>>;
  sendHeadersToParent: (headers: HeaderItem[]) => void;
  sheetTitle?: string;
  headerList?: HeaderItem[];
  //setHeaderList: (headers: HeaderItem[]) => void;
  filterArray: FilterArrayItem[];
  appliedFilters: AppliedFilter[];
  onPresetApplied?: (preset: PresetInterface) => void;
  tabs?: TabItem[];
  getTabsForSave?: () => TabItem[];
  isReportLoading?: boolean;
  permissions?: PermissionsObject;
  /** When set, column Presets control is portaled into the Data modal header. */
  presetPortalHost?: HTMLElement | null;
}

const DownloadReportPannelSection: FC<DownloadReportPannelSectionProps> = ({
  appliedHeaderList,
  //setAppliedHeaderList, // no more need
  sendHeadersToParent,
  // appliedFilters,
  // filterArray,
  sheetTitle,
  //headerList, //noe more need
  //setHeaderList, //noe more need
  onPresetApplied,
  isReportLoading = false,
  tabs,
  getTabsForSave,
  permissions,
  presetPortalHost = null,
}) => {
  const presetsDropdown = (
    <PresetsDropdown
      onPresetApplied={onPresetApplied}
      isReportLoading={isReportLoading}
      permissions={permissions}
      tabs={tabs}
      getTabsForSave={getTabsForSave}
      sheetTitle={sheetTitle}
    />
  );

  return (
    <Fragment>
      <div className='dwonload-report-pannel'>
        <Flex align='center' justify='space-between'>
          {!presetPortalHost ? presetsDropdown : null}
        </Flex>

        <ReportPanelContent
          appliedHeaderList={appliedHeaderList}
          sendHeadersToParent={sendHeadersToParent}
        />
      </div>
      {presetPortalHost
        ? createPortal(presetsDropdown, presetPortalHost)
        : null}
    </Fragment>
  );
};

export default DownloadReportPannelSection;
export type { PresetInterface } from './PresetsDropdown';
